import { useSelector } from '../../../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../../../app.store';

export const convertBoundariesSelector = (state: AppState) => state.frontendState.mapTools.boundary.convertBoundaries;
export const useConvertBoundariesSelector = () => useSelector(convertBoundariesSelector);

const boundaryConvertInProgressSelector = (state: AppState) => state.frontendState.mapTools.boundary.convertBoundaries.inProgress;
export const useBoundaryConvertInProgressSelector = () => useSelector(boundaryConvertInProgressSelector);
